<template>
    <v-container class="fill-height" fluid>
        <v-carousel cycle :show-arrows="false" hide-delimiter-background>
            <v-carousel-item>
                <v-row align="center" justify="center" class="fill-height">
                    <v-col cols="11" align="center" class="display-1">
                        {{ $t('multiartist') }}
                    </v-col>
                </v-row>
            </v-carousel-item>
            <v-carousel-item :src="require('@/assets/nwitrgb_2x.svg')" contain/>
            <v-carousel-item>
                <v-container fluid>
                    <v-row dense>
                        <v-col v-for="card in cards" :key="card.text" :cols="card.cols">
                            <v-card>
                                <v-img :src="card.src" class="align-end" gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)" height="200">
                                    <v-card-title v-text="$t(card.text)"></v-card-title>
                                </v-img>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-container>
            </v-carousel-item>
        </v-carousel>
    </v-container>
</template>

<script>
    export default {
        name: "HomePage",
        computed: {
            background() {
                // return this.$vuetify.theme.themes[(this.$vuetify.theme.dark ? 'dark' : 'light')]
                return this.$vuetify.theme.currentTheme.accent
            }
        },
        data: () => ({
            cards: [
                {text: 'coding', src: require('@/assets/go-code.png'), cols: 12},
                {text: 'consulting', src: require('@/assets/infrastructure.svg'), cols: 6},
                {text: 'ansible-deploy', src: require('@/assets/ansible.png'), cols: 6},
            ],
        }),
    }
</script>

<style scoped>
    .bg-text {
        background-color: rgba(20, 20, 20, 0.4);
    }
</style>